enum CustomPollPermissionType {
    None = "None",
    Including = "Including",
    Excluding = "Excluding",
    Restricting = "Restricting"
}

export default CustomPollPermissionType;